<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <global-table
          :per-page="10"
          :bordered="true"
          :table-detail="tableDetail"
          :table-data="getData"
          :total-data="totalRows"
          :hover="true"
          :striped="false"
          :fields="fields"
          :row-edit="customerForm"
          :redirect-detail="true"
          :show-add-button="false"
          :search-by-survey-date="true"
          caption="<i class='fa fa-align-justify'></i> Customer Survey Listing"
          @editForm="editForm"
        ></global-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "../../templates/TableNew.vue";
import interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect } from "vue-search-select";
import custom_validation from "@/templates/_customValidation.js";
import loading from "@/templates/Loading.vue";

export default {
  name: "customer-survey",
  components: { globalTable, ModelSelect, loading },
  props: {
    tableDetail: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      customer: [],
      listCustomerGroup: [],
      listZone: [],
      listVehicleDelivery: [],
      listOrderTime: [],
      listProvince: [],
      listRegencies: [],
      listDistrict: [],
      listVillage: [],
      loading: true,
      loadingSubmit: false,
      totalRows: "",
      isNonGT: false,
      fields: [
        {
          key: "customer_name",
          label: "Nama Konsumen",
          sortable: true,
          filterByFormatted: true,
        },
        {
          key: "employee_name",
          label: "Surveyor",
          sortable: true,
          filterByFormatted: true,
        },
        {
          key: "tgl_survey",
          label: "Tanggal Survey",
          sortable: true,
          filterByFormatted: true,
        },
        { key: "action", class: "text-center width-80" },
      ],
      customerForm: interfaces.customer,
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  validations() {
    if (this.isNonGT === true) {
      return custom_validation.customer.true;
    } else {
      return custom_validation.customer.false;
    }
  },
  computed: {
    accessLevel() {
      return localStorage.getItem("level") === "1" ? true : false;
    },
  },
  methods: {
    getData: function (ctx) {
      this.loading = true;
      let response = axios.post("web/customer-survey/all", ctx);
      return response
        .then((data) => {
          const items = data.data.data;
          this.totalRows = data.data.total_rows;
          this.loading = false;
          return items;
        })
        .catch((error) => {
          this.expired(error);
          this.loading = false;
          return [];
        });
    },
    init: function () {},
    editForm: function () {},
    cancelAdd: function () {
      this.$refs.myModalRef.hide();
    },
    expired: function (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: "Tambah Konsumen",
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
</style>
